import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Form from "./MemberCreateForm";

export default function MemberCreateButton({ buttonName, className }) {
  const [show, setShow] = useState(false);

  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);

  let modalHeader = "Create new member";

  return (
    <>
      <a className={className} onClick={openForm}>
        {buttonName}
      </a>

      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form closeForm={closeForm} />
        </Modal.Body>
      </Modal>
    </>
  );
}
